module.exports = __webpack_public_path__ + "static/img/m_role.2e90aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/swbnzk/m_role.png
// module id = FUFu
// module chunks = 7